import React, { useEffect } from "react"

import { Layout } from "@components/layout"
import {
  Hero,
  Attention,
  Values,
  Mission,
  Shopping,
  SpecialButton,
  Conditions,
  Reviews,
  Contact,
} from "@components/standard"

const IndexPage = ({ pageContext, location }) => {
  const { page } = pageContext
  const translationUrls = {
    pl:`/pl`,
    en:`/en`,
  }
  // if(typeof window !== "undefined"){
  //   localStorage.setItem('language', '/pl')
  // }
  return (
    <Layout {...page[0]} translationUrl={translationUrls}>
      <Hero/>
      <Attention/>
      <Values />
      <Mission />
      <Shopping />
      <SpecialButton />
      <Conditions />
      <Reviews />
      <Contact />
    </Layout>
  )
}

export default IndexPage
